import { ReportListingProps } from "src/context/authContext/types";
import { REPORT_DISPLAY_NAMES } from "src/pages/reports/types";
import { HeaderElementType } from "src/types";
import { UserType } from "src/types/users";

//:- Validation based constants
export const EMAIL_REGEX =/^[a-zA-Z0-9._'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,20}$/;
export const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{10,70}$/;

export const MAX_FILE_SIZE = 25 * 1024 * 1024;

export const US_STATES = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DC", label: "District of Colombia" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "FM", label: "Federated States of Micronesia" },
  { value: "GA", label: "Georgia" },
  { value: "GU", label: "Guam" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MH", label: "Marshall Islands" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota"},
  { value: "MS", label: "Mississippi"},
  { value: "MO", label: "Missouri"},
  { value: "MP", label: "Northern Mariana Islands"},
  { value: "MT", label: "Montana"},
  { value: "NE", label: "Nebraska"},
  { value: "NV", label: "Nevada"},
  { value: "NH", label: "New Hampshire"},
  { value: "NJ", label: "New Jersey"},
  { value: "NM", label: "New Mexico"},
  { value: "NY", label: "New York"},
  { value: "NC", label: "North Carolina"},
  { value: "ND", label: "North Dakota"},
  { value: "OH", label: "Ohio"},
  { value: "OK", label: "Oklahoma"},
  { value: "OR", label: "Oregon"},
  { value: "PA", label: "Pennsylvania"},
  { value: "PW", label: "Palau"},
  { value: "PR", label: "Puerto Rico"},
  { value: "RI", label: "Rhode Island"},
  { value: "SC", label: "South Carolina"},
  { value: "SD", label: "South Dakota"},
  { value: "TN", label: "Tennessee"},
  { value: "TX", label: "Texas"},
  { value: "UT", label: "Utah"},
  { value: "VT", label: "Vermont"},
  { value: "VI", label: "Virgin Islands"},
  { value: "VA", label: "Virginia"},
  { value: "WA", label: "Washington"},
  { value: "WV", label: "West Virginia"},
  { value: "WI", label: "Wisconsin"},
  { value: "WY", label: "Wyoming"},
];

export const ACCEPTED_FILE_EXTENSIONS: { [key: string]: string; } = {
  '.pdf': 'application/pdf',
  '.doc': 'application/msword',
  '.tiff': 'image/tiff',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.ccd': 'application/x-ccd',
  '.cda': 'application/x-cdf',
  '.ccr': 'application/x-ccr',
  '.ccda': 'application/x-ccda',
};

export const ACCEPTED_FILE_EXTENSIONS_CASE: { [key: string]: string; } = {
  '.pdf': 'application/pdf',
  '.doc': 'application/msword',
  '.tiff': 'image/tiff',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.ccd': 'application/x-ccd',
  '.cda': 'application/x-cdf',
  '.ccr': 'application/x-ccr',
  '.ccda': 'application/x-ccda',
};

export const ACCEPTED_PRECERT_FILE_EXTENSIONS: { [key: string]: string; } = {
  ...ACCEPTED_FILE_EXTENSIONS,
  '.txt': 'text/plain',
  '.jpeg': 'image/jpeg',
  '.png': 'image/png'
};


export const USER_TYPES = {
  HCP: ['GlobalDoctor', 'Practice', 'Contact', 'Organization', 'CentralManagerUsers'],
  MANUFACTURER: ['Manufacturer', 'regional_manager', 'district_manager', 'rep', 'area_manager'],
  PHARMACY: ['Pharmacy', 'PharmacyOrg'],
};

export const STATIC_CPT_CODES = [
  {
    value: '15271',
    label: '15271',
  },
  {
    value: '15273',
    label: '15273',
  },
  {
    value: '15275',
    label: '15275',
  },
  {
    value: '15277',
    label: '15277',
  },
];

export const HIDE_PATEINT_DOB_INITIALS = [
  "dyerves@scpharma.com",
  "tstone@scpharma.com",
  "jfreeman@scpharma.com",
  "thendrzak@scpharma.com",
  "mconstantino@scpharma.com",
  "mrowell@scpharma.com",
  "mhassman@scpharma.com",
  "bwarfel@scpharma.com",
  "szhang@scpharma.com",
  "wlapore@scpharma.com",
  "nhutchinson@scpharma.com",
  "dyerves@mnkd.com",
  "jfreeman@mnkd.com",
  "thendrzak@mnkd.com",
  "mrowell@mnkd.com",
  "mhassman@mnkd.com",
  "bwarfel@mnkd.com",
  "szhang@mnkd.com",
  "wlepore@mnkd.com",
  "fsullivan@mnkd.com",
  "tsanft@mnkd.com",
  "jemrich@mannkindcorp.com",
  "hpereira@mannkindcorp.com",
  "skenny@mannkindcorp.com",
  "ksears@mannkindcorp.com",
  "mcollura@mnkd.com",
  "omoreno@mnkd.com",
  "tleonard@mannkindcorp.com"
];

export const MANUFACTURER = [
  {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  {
    reportTitle:'FRM Report',
    reportName:'frm_report'
  },
  {
    reportTitle:'Calls',
    reportName:'call_report'
  },
  {
    reportTitle:'Texts',
    reportName:'text_report'
  },
  {
    reportTitle:'Denials',
    reportName:'denial_report'
  },
  {
    reportTitle:'Xfer',
    reportName:'transfer_report'
  },
  {
    reportTitle:'Login',
    reportName:'login_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  },
  {
    reportTitle:'Resource Summary',
    reportName:'resource_summary_report'
  },
  {
    reportTitle:'Co-Pay Claims Report',
    reportName:'copay_claims'
  },
  {
    reportTitle:'Local Coverage Analytics',
    reportName:'local_coverage_analytics_report'
  },
]
export const REGIONAL_MANAGER_IOVERA = [
  {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  // {
  //   reportTitle:'Xfer',
  //   reportName:'transfer_report'
  // },
  {
    reportTitle:'Login',
    reportName:'login_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
   }
  //,{
  //   reportTitle:'Co-Pay Claims Report',
  //   reportName:'copay_claims'
  // },
]
export const REGIONAL_MANAGER = [
  {
    reportTitle:'FRM Report',
    reportName:'frm_report'
  },
  // {
  //   reportTitle:'Xfer',
  //   reportName:'transfer_report'
  // },
  {
    reportTitle:'Denials',
    reportName:'denial_report'
  },
  {
    reportTitle:'Login',
    reportName:'login_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  },{
    reportTitle:'Co-Pay Claims Report',
    reportName:'copay_claims'
  },
]
export const DISTRICT_MANAGER = [
  {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  {
    reportTitle:'Login',
    reportName:'login_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  }
]
export const REP = [
  {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  // {
  //   reportTitle:'Xfer',
  //   reportName:'transfer_report'
  // },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  },
]
export const AREA_MANAGER_IOVERA = [
  {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  
  {
    reportTitle:'Login',
    reportName:'login_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  },
  
];
export const AREA_MANAGER = [
  
  {
    reportTitle:'FRM Report',
    reportName:'frm_report'
  },
  
  {
    reportTitle:'Denials',
    reportName:'denial_report'
  },
  {
    reportTitle:'Login',
    reportName:'login_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  },
  {
    reportTitle:'Co-Pay Claims Report',
    reportName:'co-pay_claims'
  }
]
export const FAM_AM = [
  {
    reportTitle:'FRM Report',
    reportName:'frm_report'
  },
  {
    reportTitle:'Denials',
    reportName:'denial_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  }
]
export const FAM_RM = [
  {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  {
    reportTitle:'FRM Report',
    reportName:'frm_report'
  },
  {
    reportTitle:'Denials',
    reportName:'denial_report'
  },
  {
    reportTitle:'Xfer',
    reportName:'transfer_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  },
  {
    reportTitle:'Co-Pay Claims Report',
    reportName:'copay_claims'
  },
]
export const ZILRETTA_REPORT = [
   {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  }
]
export const ZILRETTA_REPORT_MANUFACTURER= [
   {
    reportTitle:'AM Report',
    reportName:'am_report'
  },
  {
    reportTitle:'Portal Registrations',
    reportName:'user_report'
  }
]
export const ACCESS_TO_LOCAL_COVERAGE_REPORT = [
  "devh@cmcopilot.com", "roberta.baptista@pacira.com", "darcy.duckenfield@pacira.com",
  "copilotreport@cmcopilot.com", "demoreport@pacira.com", "timothy.mcsweeney@pacira.com"
]

// export const getReportsByRole = (userType: UserType, report_listing: ReportListingProps) => {

//   console.log("Determining reports for user type:", userType);
//   let reports: any = [];

//   // 🟢 1. Check Zilretta Access First
  
 
//   // 🟡 2. Normal Role-Based Access
//    if (userType.ref_type === "Manufacturer") {
//     reports = MANUFACTURER;
//   } else if (userType.ref_type === "regional_manager" ) {
//     reports = REGIONAL_MANAGER;
//   }
//    else if (userType.ref_type === "district_manager" ) {
//     reports = AREA_MANAGER;
//   }
//    else if (userType.ref_type === "rep") {
//     reports = REP;
//   } else if (userType.ref_type === "area_manager" ) {
//     reports = AREA_MANAGER;
//   }
//    else if (userType.ref_type === "fam_am") {
//     reports = FAM_AM;
//   } else if (userType.ref_type === "fam_rm") {
//     reports = FAM_RM;
//   } else {
//     reports = [];
//   }

//   // 🟣 3. Convert to dropdown object
//   return reports.map((r: any) => ({
//     title: r.reportTitle,
//     redirectLink: `/reports/${r.reportName.replace("_report", "")}`,
//     actionType: HeaderElementType.LINK,
//   }));
// };

const REPORT_KEY_ORDER: (keyof ReportListingProps)[] = [
  "Status Report",
  "Full Report",
  "Condensed Sales Report",
  "Field Liaison Report",
  "Incoming Fax Report",
  "Login Report",
  "Refill Report",
];

const REPORT_KEY_ORDER_MAP = new Map<keyof ReportListingProps, number>(
  REPORT_KEY_ORDER.map((key, index) => [key, index]),
);

export const getReportsByRole = (
  report_listing?: ReportListingProps,
) => {
  if (!report_listing) {
    return [];
  }

  return (
    Object.entries(report_listing) as [
      keyof ReportListingProps,
      boolean,
    ][]
  )
    .filter(
      ([reportTitle, isAllowed]) =>
        isAllowed === true &&
        Boolean(REPORT_DISPLAY_NAMES[reportTitle]),
    )
    .sort(([firstKey], [secondKey]) => {
      const firstPosition =
        REPORT_KEY_ORDER_MAP.get(firstKey) ??
        Number.MAX_SAFE_INTEGER;

      const secondPosition =
        REPORT_KEY_ORDER_MAP.get(secondKey) ??
        Number.MAX_SAFE_INTEGER;

      return firstPosition - secondPosition;
    })
    .map(([reportTitle]) => {
      const reportName =
        REPORT_DISPLAY_NAMES[reportTitle];

      return {
        title: reportTitle,
        redirectLink: `/reports/${reportName.replace(
          "_report",
          "",
        )}`,
        actionType: HeaderElementType.LINK,
      };
    });
};
